module.exports = __webpack_public_path__ + "img/epic-box.4891e22f.png";